export type StoreNames =
  | "KIWI"
  | "MENY"
  | "Coop Extra"
  | "Coop Prix"
  | "Coop Mega"
  | "Europris"
  | "Joker"
  | "REMA 1000"
  | "Obs"
  | "SPAR"
  | "Bunnpris";

type NoColour = "noColour";

interface ButtonProps {
  label: string;
  colour?: StoreNames | NoColour;
  selected?: boolean;
  dimUnselected?: boolean;
  disabled?: boolean;
  outline?: boolean;
  onClick?: (event: any) => void;
}

export const baseColourClasses: { [key in StoreNames | NoColour]: string } = {
  KIWI: "bg-[rgb(108,182,87)] text-black hover:bg-[rgb(90,150,70)]",
  MENY: "bg-[rgb(183,43,53)] text-white hover:bg-[rgb(150,30,40)]",
  "Coop Extra": "bg-[rgb(216,54,35)] text-white hover:bg-[rgb(180,40,30)]",
  "Coop Prix": "bg-[rgb(234,203,72)] text-black hover:bg-[rgb(220,190,60)]",
  "Coop Mega": "bg-[rgb(55,84,42)] text-white hover:bg-[rgb(45,70,30)]",
  Europris: "bg-[rgb(44,103,68)] text-white hover:bg-[rgb(30,80,50)]",
  Joker: "bg-[rgb(61,139,92)] text-white hover:bg-[rgb(40,110,70)]",
  "REMA 1000": "bg-[rgb(24,61,159)] text-white hover:bg-[rgb(20,50,130)]",
  Obs: "bg-[rgb(18,50,98)] text-white hover:bg-[rgb(15,40,80)]",
  Bunnpris: "bg-[rgb(251,235,91)] text-black hover:bg-[rgb(240,220,70)]",
  SPAR: "bg-[rgb(207,46,38)] border-[rgb(207,46,38)] text-white hover:bg-[rgb(170,35,30)]",

  noColour: "",
};

// Selected colors (when selected)
const selectedColourClasses: { [key in StoreNames | NoColour]: string } = {
  KIWI: "bg-[rgb(90,150,70)] text-white",
  MENY: "bg-[rgb(150,30,40)] text-white",
  "Coop Extra": "bg-[rgb(180,40,30)] text-white",
  "Coop Prix": "bg-[rgb(220,190,60)] text-black",
  "Coop Mega": "bg-[rgb(45,70,30)] text-white",
  Europris: "bg-[rgb(30,80,50)] text-white",
  Joker: "bg-[rgb(40,110,70)] text-white",
  "REMA 1000": "bg-[rgb(20,50,130)] text-white",
  Obs: "bg-[rgb(15,40,80)] text-white",
  Bunnpris: "bg-[rgb(240,220,70)] text-black",
  SPAR: "bg-[rgb(170,35,30)] text-white",

  noColour: "bg-gray-300",
};

export const Button = ({
  label,
  colour = "noColour",
  selected,
  disabled,
  outline,
  onClick,
  dimUnselected,
}: ButtonProps) => {
  let colorClass = selected
    ? selectedColourClasses[colour]
    : baseColourClasses[colour];

  if (dimUnselected && !selected) {
    colorClass += " opacity-30";
  }

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`
        inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium
        ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring 
        focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 
        [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-10 px-4 py-2 flex-1 sm:flex-none
        ${colorClass}
        ${outline ? "border border-black" : ""}
      `}
    >
      {label}
    </button>
  );
};
